'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[Services]');

function getServices(reservationService, language, beginDate, endDate, destCode, prodCode, passengers) {
    var ps = _.map(passengers, function (p) {
        return {
            Type: p.type,
            Age: p.age,
            BirthDate: p.dob
        };
    });

    var request = reservationService.getServices(language, beginDate, endDate, destCode, prodCode, ps);
    return request.then(function (result) {
        if (result) {
            var groups = processGroups(result.Regular, passengers);

            return {
                state: 'ready',
                groups: _.filter(groups, function (group) {
                    return group.available || group.guard;
                })
            };
        } else {
            // It was canceled
            return null;
        }
    }, function (error) {
        log.error('Failed to get extra services:', error);
        return {
            state: 'error',
            groups: []
        };
    });
}

function processGroups(groups, passengers) {
    return _.map(groups, function (group, i) {
        var perPassenger = group.Multiplier === 'PerPassenger';

        var processedServices = _.map(group.Services, function (service) {
            return processService(service);
        });
        _.remove(processedServices, function (service) {
            return !service.available;
        });

        var processedInstances = _.flatMap(processedServices, function (service) {
            return service.instances;
        });

        // Count how many available instances we actually have.
        var instanceCount = _.sumBy(processedServices, function (service) {
            return service.instances.length;
        });

        // Figure out the type of this group:
        // single-passengers: One service/instance, select passengers
        // group-passengers: Multiple services/instances, select passengers
        // single-prices: One service/instance, select prices
        // group-prices: Multiple services/instances, select prices
        var type = (instanceCount > 1 ? 'group' : 'single') + '-' + (perPassenger ? 'passengers' : 'prices');

        var processedPassengers = perPassenger ? _.map(passengers, function (passenger) {
            return processPassenger(passenger, processedInstances);
        }) : null;

        return {
            index: i,
            type: type,
            label: group.GroupName,

            available: _.some(processedServices, function (service) {
                return service.available;
            }),
            multiplier: group.Multiplier,
            min: _.isNil(group.Min) ? undefined : group.Min,
            max: _.isNil(group.Max) ? undefined : group.Max,

            services: processedServices,
            instances: processedInstances,
            passengers: _.filter(processedPassengers, function (passenger) {
                return passenger != null;
            }),

            // Just for display, not to be used for decisions in frontend
            id: group.GroupID,
            force: group.Force,
            guard: group.Guard
        };
    });
}

function processService(s) {
    var debugInfo = '[' + s.DestCode + ' ' + s.ProdCode + '] ';

    var processedInstances = _.map(s.Instances, function (i) {
        return processInstance(i, s);
    });

    return {
        id: serviceID(s),
        name: s.Name,
        description: s.Description,
        // description: debugInfo + s.Description,
        image: s.Image,
        instances: _.filter(processedInstances, function (instance) {
            return instance.available;
        }),
        available: _.some(processedInstances, function (instance) {
            return instance.available;
        }),

        destCode: s.DestCode,
        prodCode: s.ProdCode,
        priceGroup: s.PriceGroup
    };
}

function processInstance(instance, service) {
    var blockers = instance.Blockers.length > 0 ? ' - ' + instance.Blockers.join(' ') : '';
    var debugInfo = '[' + service.DestCode + ' ' + service.ProdCode + ' - ' + ' ' + instance.FreePlaces + ' jäljellä' + blockers + '] ';

    var processedPrices = _.map(instance.Prices, processPrice);

    var name = service.Name;

    // If there are multiple instances, include the begin (and possibly end) date in the name.
    if (service.Instances.length > 1) {
        name += ' (' + moment(instance.BeginDate).format('D.M.Y');
        if (instance.EndDate != instance.BeginDate) {
            name += ' - ' + moment(instance.EndDate).format('D.M.Y');
        }
        name += ')';
    }

    return {
        id: instanceID(service, instance),
        name: name,
        capacity: instance.FreePlaces,
        available: instance.Blockers.length === 0,
        beginDate: instance.BeginDate,
        endDate: instance.EndDate,
        prices: processedPrices,

        passengerPrices: instance.PassengerPrices
    };
}

function processPassenger(passenger, instances) {
    // Single instance
    if (instances.length === 1) {
        var instance = instances[0];
        var price = instance.passengerPrices[passenger.index];

        if (!price || price.Error) {
            return null;
        }

        return {
            id: passenger.id,
            name: passenger.name,
            priceLabel: price.Label,
            price: price.Price
        };
    }

    // Group
    var prices = {};
    _.forEach(instances, function (instance) {

        // TODO: Consider finding by ID if backend returns it
        var price = instance.passengerPrices[passenger.index];

        if (!price || price.Error) {
            return;
        }

        prices[instance.id] = {
            priceLabel: price.Label,
            price: price.Price
        };
    });

    if (_.isEmpty(prices)) {
        // Nothing in the group is available to this passenger.
        return null;
    }

    return {
        id: passenger.id,
        name: passenger.name,
        prices: prices
    };
}

function processPrice(price) {
    return {
        id: '' + price.Index,
        index: price.Index,
        name: price.Label,
        price: price.Price
    };
}

function serviceID(s) {
    return toServiceID(s.DestCode, s.ProdCode);
}

function instanceID(s, i) {
    return toInstanceID(s.DestCode, s.ProdCode, i.BeginDate, i.EndDate);
}

function lineServiceID(line) {
    return toServiceID(line.DestinationCode, line.ProductCode);
}

function lineInstanceID(line) {
    return toInstanceID(line.DestinationCode, line.ProductCode, line.BeginDate || line.StartDate, line.EndDate);
}

function toInstanceID(destCode, prodCode, beginDate, endDate) {
    var FALLBACK = 'XXXX-XX-XX'; // In case of missing date
    var begin = (beginDate || FALLBACK).substring(0, 10);
    var end = (endDate || FALLBACK).substring(0, 10);
    return toServiceID(destCode, prodCode) + '_' + begin + '_' + end;
}

function toServiceID(destCode, prodCode) {
    return '' + destCode + '_' + prodCode;
}

var winresServicesController = function () {
    function winresServicesController($scope, $rootScope, reservationService, cancelService, localizationService) {
        _classCallCheck(this, winresServicesController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.reservationService = reservationService;
        this.cancelService = cancelService;
        this.localizationService = localizationService;
    }

    _createClass(winresServicesController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Possible states:
            // initial - Starting state
            // loading - Loading new data
            // ready - Data loaded, ready to display
            // error - Something went wrong
            this.state = 'initial';

            // Pending request for data, so it can be canceled
            this.pending = null;

            // Passengers
            this.passengers = [];

            // Data to display
            this.groups = [];

            // Current values of selections, indexed by group index
            this.values = {};

            // ngModel
            this.ngModelCtrl.$render = function () {
                return _this.render(_this.ngModelCtrl.$viewValue);
            };
            this.ngModelCtrl.$isEmpty = function (value) {
                return _.every(value, function (groupChoices) {
                    if (groupChoices === undefined) {
                        return true;
                    } else if (_.isArray(groupChoices)) {
                        // List of passengers or passenger-instance pairs
                        return _.isEmpty(groupChoices);
                    } else if (_.isObject(groupChoices)) {
                        // A single price choice hash or a hash of those
                        return _.every(groupChoices, function (x) {
                            return x === 0 || _.every(x, function (y) {
                                return y === 0;
                            });
                        });
                    } else {
                        // Something else, error
                        throw new Error('Unknown kind of choices value: ' + groupChoices);
                    }
                });
            };

            // The component can only be valid when it has actually loaded its data!
            this.ngModelCtrl.$validators.ready = function (modelValue, viewValue) {
                return _this.state === 'ready';
            };

            this.$scope.$watchGroup([function () {
                return _this.destCode;
            }, function () {
                return _this.prodCode;
            }, function () {
                return _this.beginDate;
            }, function () {
                return _this.endDate;
            }, function () {
                return _this.inputPassengers;
            }, function () {
                return _this.allowedPassengerNumbers;
            }], function () {
                _this.updatePassengers(_this.inputPassengers, _this.allowedPassengerNumbers);
                _this.load(_this.destCode, _this.prodCode, _this.beginDate, _this.endDate, _this.passengers);
            });

            // This was added to winres-transport, is it needed here too?
            // Maybe add it to the wrapper instead, and just have this control
            // return errors the standard way?
            this.$scope.$on('winresReservationShowErrors', function () {
                return _this.error = true;
            });
        }
    }, {
        key: 'load',
        value: function load(destCode, prodCode, beginDate, endDate, passengers) {
            var _this2 = this;

            if (this.pending) {
                log('There is a pending request. Canceling it.');
                this.cancelService.cancel(this.pending);
                this.pending = null;
            }

            if (!destCode || !beginDate || !endDate) {
                log('Parameters not provided yet.');
                this.state = 'initial';
                return;
            } else {
                this.state = 'loading';
            }

            log('Loading.', destCode, prodCode || '', beginDate, endDate, passengers);

            var language = this.localizationService.getLanguage();

            var request = getServices(this.reservationService, language, beginDate, endDate, destCode, prodCode, passengers);
            this.pending = request;

            request.then(function (result) {
                if (!result) {
                    // Canceled promise.
                    return;
                } else if (request !== _this2.pending) {
                    log('Ignoring completed request because a newer one is pending.');
                    return;
                }
                _this2.state = result.state; // ready or error

                _this2.groups = result.groups;

                log('Final groups:', _this2.groups);
            }).catch(function (error) {
                // This error is unlikely since setting the component state is currently
                // trivial. Included anyway just to be sure.
                log.error('Failed to set component state:', error);
                _this2.state = 'error';
                _this2.groups = [];
            }).then(function () {
                if (_this2.pending === request) {
                    // The request that just completed was the most recent pending one.
                    // log('The pending request has completed.');
                    _this2.pending = null;
                }
                _this2.update();

                // Re-run validators to make sure we catch the ready state.
                _this2.ngModelCtrl.$validate();
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var oldChoices = this.choices;

            // this.choices = [];

            if (this.state !== 'ready') return;

            this.render(this.ngModelCtrl.$viewValue);

            // This is to make shopping tabs know if there are any services.
            this.broadcastShoppingTabsStatus();

            // log('Update:', passengers, groups, lines);

            // _.forEach(model, line => {
            // const routeValue = routeCodesToValue(line.DestinationCode, line.ProductCode);
            // const group = _.find(groups, g => {
            //     const route = findRoute(g, routeValue);
            //     // Comment out debug log below once we find out what causes the error with "dates"
            //     // console.log('[WinresTransport] Possible match for', routeValue, ':', route);
            //     return route
            //         && route.dates.begin.isSame(line.BeginDate, 'day')
            //         && route.dates.end.isSame(line.EndDate, 'day');
            // });
            // if (!group) {
            //     console.warn('[WinresTransport] Could not find route', routeValue, line.BeginDate, line.EndDate);
            //     return;
            // }
            // _.forEach(line.PassengerAssignments, pa => {
            //     const passenger = passengers.find(p => p.index === pa.PassengerNumber);
            //     if (!passenger) {
            //         console.warn('[WinresTransport] Could not find passenger', pa.PassengerNumber);
            //         return;
            //     }
            //     const route = findRoute(group, routeValue);
            //     const stop = route && findStop(route, pa.BusStopID);
            //     if (!stop) {
            //         console.warn('[WinresTransport] Could not find stop', pa.BusStopID);
            //         return;
            //     }
            //     this.choices[group.index][passenger.index] = {
            //         route: routeValue,
            //         stop: pa.BusStopID,
            //     };
            // });
            // });

            // Restore incomplete choices not reflected in the model,
            // i.e. cases where the a route is chosen but a stop is not.
            // _.forEach(oldChoices, (group, groupIndex) => {
            //     if (this.choices[groupIndex]) {
            //         _.forEach(group, (choice, passengerIndex) => {
            //             if (this.choices[groupIndex][passengerIndex] &&
            //                 !this.choices[groupIndex][passengerIndex].route &&
            //                 choice && choice.route && !choice.stop) {
            //                 // console.log('[WinresTransport] Restoring incomplete choice:',
            //                             // groupIndex, passengerIndex, choice.route);
            //                 this.choices[groupIndex][passengerIndex].route = choice.route;
            //             }
            //         });
            //     }
            // });
        }
    }, {
        key: 'updatePassengers',
        value: function updatePassengers(passengers, allowedPassengerNumbers) {
            // log('Updating passengers.', passengers);

            // Number the passengers _before_ filtering so we have the correct passenger
            // numbers for creating product lines.
            // If passenger numbers are later included in the input, this part can be changed.
            var numbered = _.map(passengers, function (p, i) {
                return { number: i, passenger: p };
            });

            // If the list of allowed passengers was provided, remove any
            // passengers who are not on the list.
            if (_.isArrayLike(allowedPassengerNumbers)) {
                numbered = _.filter(numbered, function (x) {
                    return _.includes(allowedPassengerNumbers, x.number);
                });
            }

            this.passengers = _.map(numbered, function (x, i) {
                var p = x.passenger;

                return {
                    // Index in the final passenger array.
                    index: i,

                    // Unique ID, used as a hash key. Might later be a GUID generated
                    // when new passengers are added.
                    id: 'P' + x.number,

                    // The passenger number, corresponding to PassengerNumber in assignment list.
                    // Not the same as index if only some passengers are allowed for this service!
                    number: x.number,

                    // The passenger's type (the name "Gender" is misleading since it also contains
                    // age information, e.g. CH/F).
                    type: p.Gender,

                    // The passenger's date of birth in ISO format.
                    dob: moment(p.BirthDate, [moment.ISO_8601, 'DD.MM.YYYY']).format('Y-MM-DD'),

                    // The passenger's age, in case the real date of birth is not yet available.
                    age: p.ArrivalAge || null,

                    // The following are only for display, not used to make decisions.

                    // The displayed name of the passenger, used as a label.
                    name: p.FirstName + ' ' + p.LastName
                };
            });

            // log('Updated passengers.', this.passengers);
        }

        // Parse product lines and set this.values based on them

    }, {
        key: 'render',
        value: function render(value) {
            var _this3 = this;

            // log('Input:', value);

            if (!_.isArray(value)) {
                log.warning('Provided model value is invalid:', value);
                value = [];
            }

            // Group lines by instance IDs
            var iidLines = _.groupBy(value, lineInstanceID);

            var values = {};

            // log(iidLines);

            _.forEach(this.groups, function (group) {
                _.forEach(group.services, function (service) {
                    _.forEach(service.instances, function (instance) {
                        var lines = iidLines[instance.id];
                        _.forEach(lines, function (line) {
                            _this3.addLineToValues(values, _this3.passengers, group, service, instance, line);
                        });
                    });
                });
            });

            // If some groups leave absolutely no choice for the user,
            // set the values automatically.
            var autopicked = false;

            _.forEach(this.groups, function (group) {
                // If there is absolutely no choice for the user,
                // set the values automatically.
                if (group.type === 'single-passengers' && group.force) {
                    // There is always a single instance...
                    var instance = group.instances[0];
                    if (!instance) {
                        // ...unless even that instance is unavailable.
                        // In that case, we can't pick anything.
                        return;
                    }
                    // Add all possible passengers.
                    // If there is not enough capacity, pick the first ones on the list.
                    var capacity = instance.capacity;
                    var firstPassengers = _.slice(group.passengers, 0, capacity);
                    var picks = _.map(firstPassengers, function (p) {
                        return p.id;
                    });
                    // Does this change anything, or does the group already
                    // have the same values?
                    var changed = !_.isEqual(picks, values[group.index]);
                    if (changed) {
                        log('Auto-picked values for group', group.index, ':', picks);
                        values[group.index] = picks;
                        autopicked = true;
                    }
                }
            });

            this.values = values;

            // If something was auto-picked, we must read the new values back immediately
            // so the shopping cart gets updated.
            if (autopicked) {
                log('Auto-picked something. Re-reading...');
                this.read();
            }
        }

        // Add the provided line's selections to the values object

    }, {
        key: 'addLineToValues',
        value: function addLineToValues(values, passengers, group, service, instance, line) {
            if (group.type === 'single-passengers') {
                var pids = this.getLinePassengerIDs(line);
                var vg = this.getValuesGroup(values, group);
                _.forEach(pids, function (pid) {
                    vg.push(pid);
                });
            } else if (group.type === 'group-passengers') {
                var _pids = this.getLinePassengerIDs(line);
                var pairs = _.map(_pids, function (pid) {
                    return [instance.id, pid];
                });
                var _vg = this.getValuesGroup(values, group);
                _.forEach(pairs, function (pair) {
                    _vg.push(pair);
                });
            } else if (group.type === 'single-prices') {
                var _vg2 = this.getValuesGroup(values, group);
                _.forEach(line.PriceSelections, function (ps) {
                    _vg2[ps.PriceIndex] = ps.Amount;
                });
            } else if (group.type === 'group-prices') {
                var vi = this.getValuesInstance(values, group, instance);
                _.forEach(line.PriceSelections, function (ps) {
                    vi[ps.PriceIndex] = ps.Amount;
                });
            }
        }
    }, {
        key: 'getValuesInstance',
        value: function getValuesInstance(values, group, instance) {
            var vg = this.getValuesGroup(values, group);
            if (!vg[instance.id]) {
                vg[instance.id] = {};
            }
            return vg[instance.id];
        }
    }, {
        key: 'getValuesGroup',
        value: function getValuesGroup(values, group) {
            if (!values[group.index]) {
                this.initValuesGroup(values, group);
            }
            return values[group.index];
        }
    }, {
        key: 'initValuesGroup',
        value: function initValuesGroup(values, group) {
            if (group.type === 'single-passengers' || group.type === 'group-passengers') {
                values[group.index] = [];
            } else {
                values[group.index] = {};
            }
        }
    }, {
        key: 'getLinePassengerIDs',
        value: function getLinePassengerIDs(line) {
            var numbers = _.map(line.PassengerAssignments, function (pa) {
                return pa.PassengerNumber;
            });
            var passengers = _.filter(this.passengers, function (p) {
                return _.includes(numbers, p.number);
            });
            return _.map(passengers, function (p) {
                return p.id;
            });
        }
    }, {
        key: 'read',
        value: function read() {
            var _this4 = this;

            // log('Read:', this.values);

            // Generate new-style product lines (accepted by Cloud as input)
            var productLines = _.flatMap(this.values, function (choices, groupIndex) {
                if (choices === undefined) {
                    // The group is currently invalid, user choices don't fulfill
                    // requirements (max etc) yet.
                    // If even incomplete choices should be output as product lines,
                    // the standard Angular way of telling ng-model to return even
                    // invalid values can be used.
                    // By default, ng-model returns invalid when the control's
                    // validators say the value is invalid.
                    return [];
                }

                var group = _.find(_this4.groups, function (g) {
                    return g.index == groupIndex;
                });

                var link = {
                    DestCode: _this4.destCode,
                    ProdCode: _this4.prodCode || null,
                    BeginDate: _this4.beginDate,
                    EndDate: _this4.endDate,
                    GroupID: group.id,
                    Force: group.force
                };

                if (group.type === 'single-passengers') {
                    // Group only has a single service and a single instance of it
                    var service = group.services[0];
                    var instance = group.instances[0];
                    // Choices is a list of passenger IDs
                    var passengers = _.filter(_this4.passengers, function (p) {
                        return _.includes(choices, p.id);
                    });
                    var line = makePassengerProductLine(link, service, instance, passengers);
                    return [line];
                } else if (group.type === 'group-passengers') {
                    // Group has multiple services and/or instances of them
                    // Choices is a list of [<instance ID>, <passenger ID>] pairs.

                    // Unpack choices into a hash, keyed by instance ID
                    // Example: { 'STH-MUS_2019-01-10_2019-01-10': ['P0', 'P2'], ... }
                    var choicesByInstance = _.groupBy(choices, function (c) {
                        return c[0];
                    });
                    var pidsByInstance = _.mapValues(choicesByInstance, function (cs) {
                        return _.map(cs, function (c) {
                            return c[1];
                        });
                    });

                    return _.map(pidsByInstance, function (pids, iid) {
                        var passengers = _.filter(_this4.passengers, function (p) {
                            return _.includes(pids, p.id);
                        });
                        var instance = _.find(group.instances, function (i) {
                            return i.id === iid;
                        });
                        var service = _.find(group.services, function (s) {
                            return _.includes(s.instances, instance);
                        });
                        return makePassengerProductLine(link, service, instance, passengers);
                    });
                } else if (group.type === 'single-prices') {
                    // Group only has a single service and instance of it.
                    var _service = group.services[0];
                    var _instance = group.instances[0];
                    // Choices is a hash from price IDs to amounts
                    var _line = makePriceProductLine(link, _service, _instance, choices);
                    return [_line];
                } else if (group.type === 'group-prices') {
                    // Group has multiple services and/or instances of them
                    // Choices is a hash from instance IDs to choice hashes,
                    // where a choice hash is as above in single-prices.
                    return _.map(choices, function (priceChoices, iid) {
                        var instance = _.find(group.instances, function (i) {
                            return i.id === iid;
                        });
                        var service = _.find(group.services, function (s) {
                            return _.includes(s.instances, instance);
                        });
                        return makePriceProductLine(link, service, instance, priceChoices);
                    });
                }

                return [];
            });

            // Drop any lines that contain no actual selections at all.
            _.remove(productLines, function (line) {
                return line.Amount === 0;
            });

            // log('Output:', productLines);
            this.ngModelCtrl.$setViewValue(productLines);
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.servicesForm && this.servicesForm.$valid;
        }

        // This is to make shopping tabs know if there are any services.

    }, {
        key: 'broadcastShoppingTabsStatus',
        value: function broadcastShoppingTabsStatus() {
            this.$rootScope.$broadcast('hasServices', _.some(this.groups, function (group) {
                return group.services.length > 0;
            }));
        }
    }]);

    return winresServicesController;
}();

// function initValues(groups) {
//     const values = {};
//     _.forEach(groups, group => {
//         values[group.index] = initChoices(group);
//     });
//     return values;
// }

// function initChoices(group) {
//     if (group.type === 'single-passengers') {
//         return [];
//     }
//     else if (group.type === 'group-passengers') {
//         // Currently the same as above, since it's a list of pairs and not an object
//         return [];
//     }
//     else if (group.type === 'single-prices') {
//         return initPriceChoices(group.instances[0].prices);
//     }
//     else if (group.type === 'group-prices') {
//         const hash = {};
//         _.forEach(group.instances, instance => {
//             hash[instance.id] = initPriceChoices(instance.prices);
//         });
//         return hash;
//     }
//     else {
//         throw new Error('Unknown group type: ' + group.type);
//     }
// }

// function initPriceChoices(prices) {
//     const hash = {};
//     _.forEach(prices, price => {
//         hash[price.id] = 0;
//     });
//     return hash;
// }


function makePassengerProductLine(link, service, instance, passengers) {
    return {
        Amount: passengers.length,
        DestinationCode: service.destCode,
        ProductCode: service.prodCode,
        BeginDate: instance.beginDate,
        EndDate: instance.endDate,
        PassengerAssignments: _.map(passengers, function (p, i) {
            var price = instance.passengerPrices[p.index];

            return {
                PassengerNumber: p.number,
                ProductNumber: i + 1,

                // Extra info for generating old-style product lines
                WS_PassengerName: p.name,
                WS_PriceLabel: price.Label,
                WS_Price: price.Price
            };
        }),
        PriceGroup: service.priceGroup,
        Link: link,

        // Extra info for generating old-style product lines
        WS_ProductName: service.name
    };
}

function makePriceProductLine(link, service, instance, choices) {
    // Drop any empty choices to avoid creating extra PriceSelections entries
    choices = _.pickBy(choices, function (amount) {
        return amount > 0;
    });

    return {
        Amount: _.sum(_.values(choices)),
        DestinationCode: service.destCode,
        ProductCode: service.prodCode,
        BeginDate: instance.beginDate,
        EndDate: instance.endDate,
        PriceSelections: _.map(choices, function (amount, priceID) {
            var price = _.find(instance.prices, function (p) {
                return p.id === priceID;
            });

            return {
                PriceIndex: price.index,
                Amount: amount,

                // Extra info for generating old-style product lines
                WS_PriceLabel: price.name,
                WS_UnitPrice: price.price
            };
        }),
        PriceGroup: service.priceGroup,
        Link: link,

        // Extra info for generating old-style product lines
        WS_ProductName: service.name
    };
}

winresServicesController.$inject = ['$scope', '$rootScope', 'reservationService', 'cancelService', 'localizationService'];

_module3.default.component('winresServices', {
    template: require('./winresServices.html'),
    controller: winresServicesController,
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        heading: '@',

        destCode: '@',
        prodCode: '@', // May be left blank

        beginDate: '@',
        endDate: '@',

        inputPassengers: '<passengers',

        // List of passenger numbers (array indexes) of the passengers
        // who are allowed to pick these services.
        allowedPassengerNumbers: '<',

        ngModel: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServices/winresServices.js
// module id = 447
// module chunks = 2